import React, { useState } from "react";
import StudentNav from "./StudentNav";
import StudentSidebar from "./StudentSidebar";
import "./StuStyles/StudentDashboardLayout.css";
import StudentDashboardRoutes from "./StudentDashboardRoutes";
import StudentChangePassword from "./pages/StudentChangePassword";

function StudentDashboardLayout() {
  const [showChangePassword, setShowChangePassword] = useState(false);

  return (
    <div className="student-layout">
      <StudentNav onChangePassword={() => setShowChangePassword(true)} />
      <StudentSidebar />

      <main className="student-main-content">
        {showChangePassword ? (
          <StudentChangePassword onClose={() => setShowChangePassword(false)} />
        ) : (
          <StudentDashboardRoutes />
        )}
      </main>
    </div>
  );
}

export default StudentDashboardLayout;
